import { css } from '@emotion/react';
export const overlayBackground = css `
  background: rgba(0, 0, 0, 0.55);
`;
export const overlayTransparent = css `
  background: rgba(0, 0, 0, 0);
`;
